import { Component, ElementRef, OnInit } from '@angular/core';
import { TranslationService } from '@proximus/ng-common';
import { Location } from '@angular/common';
import { getPiiServiceId } from '../../../../shared/pii/pii.utils';

@Component({
  selector: 'mprd-credit-announcements',
  templateUrl: './credit-announcements.component.html',
})
export class CreditAnnouncementsComponent implements OnInit {
  prepaidNumber: string;
  constructor(
    private translationService: TranslationService,
    private elementRef: ElementRef,
    private location: Location,
  ) {
    this.translationService.parse(this.elementRef.nativeElement);
  }

  ngOnInit() {
    this.prepaidNumber = getPiiServiceId();
  }

  navigateBack(): void {
    this.location.back();
  }
}
